import React, { Component } from "react";
import Switch, {ReactSwitchProps} from "react-switch";
import "./CustomSwitch.scss";

class CustomSwitch extends Component {
  props: {
    handleChange: (event: any) => void,
    switchlabel: string,
    switchlabelbefore?: string | undefined
  } & Omit<ReactSwitchProps, 'onChange'>;
  render() {
    const { handleChange, ...rest} = this.props;
    return (
      <div className="customSwitch">
        <label>
          <span>{this.props.switchlabelbefore}</span>
          <Switch
            {...rest}
            onChange={this.props.handleChange}
            checked={this.props.checked}
            className={`react-switch ${this.props.className || ""}`}
            height={9}
            width={17}
            borderRadius={6}
          />
          <span>{this.props.switchlabel}</span>
        </label>
      </div>
    );
  }
}

export { CustomSwitch };
